import { useModuleByCodeParam } from '@shared/hooks/use-module-by-code-param.ts';
import * as st from './styles.module.scss';

interface Props {
  price: number;
  partnerPrice?: number;
  quantity: number;
}

export const Price = ({ price, partnerPrice, quantity }: Props) => {
  const { permissions } = useModuleByCodeParam();

  const showPrice = (price: number, quantity: number, partnerPrice?: number) => {
    return (
      (permissions.can_sell && partnerPrice ? partnerPrice * quantity : price * quantity) / 100
    ).toLocaleString();
  };

  return (
    <div className={st.price}>
      <div className={st.price__main}>{showPrice(price, quantity, partnerPrice)} </div>{' '}
      <div className={st.price__currentcy}>RUB</div>
    </div>
  );
};
